import { render } from "./ProfesionalDetalle.vue?vue&type=template&id=b90a74b6&ts=true"
import script from "./ProfesionalDetalle.vue?vue&type=script&lang=ts"
export * from "./ProfesionalDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__